<template>
<div>
    <div class="pc">
        <div class="right-bg"><img src="@/assets/newImages/common/common-icon.png" alt=""></div>
        <div class="content">
            <!-- 标题 -->
            <div class="con-header"><p>展厅导览</p></div>
            <div class="con-main">
                <div class="main-top">
                    <div class="main-three">
                        <div class="three flexCenter" v-for="(item, key) in threeList" :key="key" :class="{'three-active':threeIndex === key }" @click="chooseThree(key)">
                            <div class="line"></div>
                            <p>{{item.cateName}}</p>
                            <span></span>
                        </div>
                    </div>
                    <div class="input-div">
                        <input type="text" name="" id="" v-model="keyWords" @keyup.enter="doSearch()" placeholder="请输入关键字搜索">
                        <div class="search" @click="doSearch()">
                            <img src="@/assets/newImages/hotNews/search.png" alt="search">
                        </div>
                    </div>
                </div>
                <div class="main" :style="{height:pageHeight}">
                    <div class="main-list" v-if="listMain.length>0">
                        <div class="main-list-one">
                            <div class="one-list" v-for="(item,key) in listMain" :key="key" @click="goDetail(item)">
                                <div class="img"><img :src="item.coverImageRealPath" alt=""></div>
                                <div class="text">
                                    <p class="title">{{item.title}}</p>
                                    <p class="p">{{item.summary}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="main-list" style="display:flex;" v-if="listMain.length==0&&isSearch">
                        <p style="color:gray;font-size:24px;margin:auto;">暂无您要搜索的内容</p>
                    </div>
                    <div class="main-list" style="display:flex;" v-if="listMain.length==0&&!isSearch">
                        <p style="color:gray;font-size:24px;margin:auto;"></p>
                    </div>
                </div>
            </div> 
        </div>
    </div>
    <div class="wap">
        <div class="page-img"><img src="@/assets/newImages/common/navWap/page-img.png" alt=""></div>
        <div class="content">
            <!-- 标题 -->
            <div class="con-header"><p>展厅导览</p></div>
            <div class="con-main">
                <div class="input-div">
                    <input type="text" name="" id="" v-model="keyWords" placeholder="请输入关键字搜索">
                    <div class="search" @click="doSearch()">
                        <img src="@/assets/newImages/hotNews/search.png" alt="search">
                    </div>
                </div>
                <div class="main-top">
                    <div class="main-three">
                        <div class="three flexCenter" v-for="(item, key) in threeList" :key="key" :class="{'three-active':threeIndex === key }" @click="chooseThree(key)">
                            <div class="line"></div>
                            <p>{{item.cateName}}</p>
                            <span></span>
                        </div>
                    </div>
                </div>
                <div class="main">
                    <div class="main-list" v-if="listMain.length>0">
                        <div class="one-list" v-for="(item,key) in listMain" :key="key" @click="goDetail(item)">
                            <div class="img"><img :src="item.coverImageRealPath" alt=""></div>
                            <div class="text">
                                <p class="title">{{item.title}}</p>
                                <p class="p">{{item.summary}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="main-list" style="display:flex;background:#fff;height:50vw;" v-if="listMain.length==0&&isSearch">
                        <p style="color:gray;font-size:16px;margin:auto;">暂无您要搜索的内容</p>
                    </div>
                    <div class="main-list" style="display:flex;background:#fff;height:50vw;" v-if="listMain.length==0&&!isSearch">
                        <p style="color:gray;font-size:16px;margin:auto;"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
    
</template>
<script>
import api from '../api';
import { stripHtmlTags } from '@/utils/tool';
    export default {
        name: "exhibitionGuide",
        data(){
            return{
                pageHeight:'',
                height:document.documentElement.clientHeight,
                width:document.documentElement.clientWidth,
                threeList:[{one:"行业馆"},{one:"产业馆"},{one:"生态馆"}],
                threeIndex:0,//默认行业馆
                listMain:[],
                keyWords: '',
                parentList: [],
                isSearch: false,
            }
        },
        created(){
            this.showHeight();
            this.getExtHall();
            this.getExtHallParent();
        },
        computed:{
        },
        methods: {
            // 内容有效区域高度
            showHeight(){
                this.pageHeight = this.height-252/1920*this.width-63/1920*this.width+"px"
            },
            // 切换行业馆
            chooseThree(index){
                this.threeIndex = index;
                this.doSearch();

                // 埋码
                this.$maima.exhibition_page_top_tab_click(this.threeList[index].cateName, this.parentList[index].m_product_tag, this.parentList[index].m_industry_tag);
            },
            async goDetail(item){

                // 埋码
                // let res = await api.getFileFolder(item.folderId);
                // let zipNames = '', temp = [];
                // if(res.length > 0){
                //     res.map(item=>{
                //         temp.push(item.name);
                //     });
                // }
                // zipNames = temp.join('^');
                this.$maima.exhibition_page_detail_click(this.threeList[this.threeIndex].cateName, item.m_product_tag, item.m_industry_tag, item.title);

                this.$router.push({
                    path: '/exhibitionDetail',
                    query: {
                        id: item.articleCategoryId
                    }
                })
            },
            getExtHall(){
                let that = this;
                api.getExthallList()
                .then(res=>{
                    that.threeList = res;
                    that.checkHash();
                })
                .catch(err=>{
                });
            },
            doSearch(){
                if(this.keyWords){
                    let data = this.threeList[this.threeIndex].child;
                    let res = [];
                    data.map(item=>{
                        if(item.seoWords.indexOf(this.keyWords) != -1){
                            res.push(item);
                        }
                    });
                    this.listMain = res;
                    this.isSearch = true;

                    // 埋码
                    this.$maima.exhibition_page_search_click(this.keyWords);
                }else{
                    this.listMain = this.threeList[this.threeIndex].child;
                    this.isSearch = false;
                }
            },
            checkHash(){
                let hash = localStorage.getItem('eco_2021_exhibition_hash');
                if(hash){
                    localStorage.setItem('eco_2021_exhibition_hash', '');
                    let data = this.threeList;
                    data.map((item, index)=>{
                        if(item.cateName == hash){
                            this.threeIndex = index;
                        }
                    });
                }
                this.listMain = this.threeList[this.threeIndex].child;
            },
            getExtHallParent(){
                let that = this;
                api.getExthallParentList()
                .then(res=>{
                    that.parentList = res;
                })
                .catch(err=>{
                });
            },
        },
    }   
</script>

<style scoped lang="scss">
*{
    box-sizing: border-box ;
    padding: 0;
    margin: 0;
}
.flex{
    display: flex;
}
.pc{
    position: relative;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background: url('../assets/newImages/common/common-bg.png') no-repeat center center/cover;
    .right-bg{
        position: absolute;
        bottom: 0;
        right: 0;
        width: pxToVw(480);
        height: pxToVw(403);
        img{
            width: 100%;
        }
    }
    .content{
        width: pxToVw(1600);
        margin-left: pxToVw(233);//87
        padding-top: pxToVw(49);
        .con-header{
            width: 100%;
            height: pxToVw(115);
            margin-bottom: pxToVw(21);
            p{  
                width: pxToVw(351);
                height: pxToVw(115);
                padding: pxToVw(39) 0 0 pxToVw(92);
                font-size: pxToVw(43);
                font-family: "FZLT-blackBold";
                color: #FFF;
                line-height: pxToVw(52);
                background: url("../assets/newImages/common/common-title-bg.png")no-repeat center center/cover;
            }
        }
        .con-main{
            width: pxToVw(1540);
            margin-left: pxToVw(60);
            padding-top: pxToVw(67);
            position: relative;
            .main-top{
                width: 100%;
                height: pxToVw(80);
                position: absolute;
                top: 0;left: 0;
                z-index: 2;
                padding-right: pxToVw(17);
                display: flex;
                justify-content: space-between;
                .main-three{
                    width: pxToVw(689);
                    height: pxToVw(80);
                    padding: 0 pxToVw(7);
                    background: #FFFFFF;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    justify-content: space-between;
                    box-shadow: 0px 2px pxToVw(5) 0px rgba(234,234,234,0.5);
                    border-radius: 2px pxToVw(40) 2px pxToVw(30);
                    .three{
                        position: relative;
                        width: pxToVw(225);
                        height: pxToVw(80);
                        &:nth-child(3){
                            .line{
                                display: none;
                            }
                        }
                        .line{
                            position: absolute;
                            top: pxToVw(20);
                            right: 0;
                            width: 1px;
                            height: pxToVw(40);
                            background: #949494;
                            opacity: 0.3;
                        }
                        p{
                            font-size: pxToVw(27);
                            font-family: "FZLT-blackLittle";
                            color: #333333;
                            text-align: center;
                            line-height: pxToVw(38);
                            text-shadow: 0 pxToVw(3) pxToVw(5) rgba(234, 234, 234, 0.5);
                        }
                        span{
                            display: none;
                            position: absolute;
                            bottom: pxToVw(-2);
                            left: 50%;
                            width: pxToVw(40);
                            transform: translateX(-50%);
                            height: pxToVw(4);
                            background: #C50819;
                            border-radius: pxToVw(5);
                        }
                    }
                    .three-active{
                        p{
                            color: #C50819;
                        }
                        span{
                            display: block;
                        }
                    }
                }
                .input-div{
                    margin-top: pxToVw(11);
                    width: pxToVw(316);
                    height: pxToVw(40);
                    background: rgba($color: #FFF, $alpha: 0.9);
                    box-shadow: 0px 0px pxToVw(27) 0px rgba(231,231,231,0.5);
                    border-radius: pxToVw(23);
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 pxToVw(16) 0 pxToVw(33);
                    input{
                        width: pxToVw(225);
                        height: pxToVw(40);
                        font-size: pxToVw(19);
                        color: #333;
                        line-height: pxToVw(23);
                        border: none;
                        background: none;
                        &::placeholder{
                            color: #AAA;
                        }
                    }
                    .search{
                        width: pxToVw(40);
                        height: pxToVw(40);
                        padding: pxToVw(10);
                        cursor: pointer;
                        img{
                            vertical-align: top;
                            width: pxToVw(21);
                            height: pxToVw(21);
                        }
                    }
                }
            }
            .main{
                width: 100%;
                padding-right: pxToVw(20);
                .main-list{
                    width: 100%;
                    height: 100%;
                    position: relative;
                    background: rgba(255, 255, 255, 0.9);
                    padding: pxToVw(20) 0;
                    box-shadow: 0px 0px pxToVw(27) 0px rgba(231,231,231,0.5);
                    border-radius: pxToVw(3);
                    .main-list-one{
                        position: relative;
                        width: pxToVw(1540);
                        height: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        padding: pxToVw(65) 0 0 pxToVw(30);
                        overflow-y: scroll;
                        scrollbar-width: none;
                        -ms-overflow-style: none;
                        &::-webkit-scrollbar{
                            width: 3px;
                            height: 100%;
                            background: none;
                        }
                        &::-webkit-scrollbar-track{
                            background: none;
                        }
                        &::-webkit-scrollbar-thumb{
                            background: rgba(221, 221, 221, 0.6);
                        }
                        .one-list{
                            width: pxToVw(349);
                            height: pxToVw(308);
                            cursor: pointer;
                            margin: 0 pxToVw(20) pxToVw(27) 0;
                            border-radius: pxToVw(3);
                            .img{
                                width: pxToVw(349);
                                height: pxToVw(196);
                                background: #E6E6E6;
                                border-radius: pxToVw(3);
                                display: flex;
                                align-items: center;
                                img{
                                    vertical-align: top;
                                    // width: pxToVw(341);
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .text{
                                width: 100%;
                                .p{
                                    height: pxToVw(50);
                                    overflow: hidden;
                                    font-size: pxToVw(16);
                                    color: #AAAAAA;
                                    line-height: pxToVw(29);
                                    display: -webkit-box;
                                    -webkit-line-clamp: 2;
                                    -webkit-box-orient: vertical;
                                    text-overflow :ellipsis; 
                                }
                                .title{
                                    margin: pxToVw(19) 0 pxToVw(8);
                                    font-size: pxToVw(19);
                                    color: #333333;
                                    line-height: pxToVw(23);
                                    overflow: hidden;
                                    text-overflow :ellipsis; 
                                    white-space: nowrap; 
                                }
                            }
                        }
                    }
                }
            }
            
        }
    }
}
.wap{
    display: none;
}
@media screen and (max-width:767px) {
    .pc{
        display: none;
    }
    .wap{
        display: block;
        position: relative;
        z-index: 2;
        width: 100%;
        height: auto;
        min-height: 100vh;
        padding: 10vw 0 13.3vw;
        background: url('../assets/newImages/exhibitionGuide/wap-bg.png')no-repeat center center/cover;
        .page-img{
            position: absolute;
            bottom: 0;
            z-index: -1;
            right: 0;
            width: 38.1vw;
            height: 25.1vw;
            img{
                width: 38.1vw;
                height: 25.1vw;
            }
        }
        .content{
            width: 100%;
            border-top: 1px solid #DDDDDD;
            .con-header{
                height: 12.3vw;
                margin: 3.2vw 0 2.3vw;
                width: 100%;
                text-align: left;
                p{  
                    width: 37.6vw;
                    height: 12.3vw;
                    margin-left: -2.8vw;
                    padding: 4.1vw 0 0 10vw;
                    font-size: 4.3vw;
                    font-family: "FZLT-blackBold";
                    color: #FFF;
                    line-height: 5.2vw;
                    background: url("../assets/newImages/common/navWap/page-title.png") no-repeat center center/cover;
                }
            }
            .con-main{
                width: 90.9vw;
                margin: 0 auto;
                position: relative;
                 .input-div{
                    width: 100%;
                    height: 8vw;
                    background: #FFF;
                    box-shadow: 0px 0px 4vw 0px rgba(231,231,231,0.5);
                    border-radius: 4vw;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 2.7vw 0 5.2vw;
                    input{
                        width: 75vw;
                        height: 8vw;
                        font-size: 3.2vw;
                        color: #333;
                        line-height: 3.6vw;
                        border: none;
                        background: none;
                        &::placeholder{
                            color: #AAA;
                        }
                    }
                    .search{
                        width: 8vw;
                        height: 8vw;
                        padding: 2.4vw;
                        cursor: pointer;
                        img{
                            vertical-align: top;
                            width: 3.1vw;
                            height: 3.1vw;
                        }
                    }
                }
                .main-top{
                    width: 100%;
                    height: 10.7vw;
                    margin-top: 2.7vw;
                    display: flex;
                    justify-content: space-between;
                    .main-three{
                        width: 90.9vw;
                        height: 10.7vw;
                        padding: 0 3.2vw 0 3.7vw;
                        background: #FFFFFF;
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        // justify-content: space-between;
                        box-shadow: 0px 0.3vw 0.7vw 0px rgba(234,234,234,0.5);
                        border-radius: 0.2vw 4vw 0.2vw 4vw;
                        .three{
                            position: relative;
                            width: 27.9vw;
                            height: 10.7vw;
                            &:nth-child(3){
                                .line{
                                    display: none;
                                }
                            }
                            .line{
                                position: absolute;
                                top: 3.1vw;
                                right: 0;
                                width: 2px;
                                height: 4.5vw;
                                background: #949494;
                                opacity: 0.3;
                            }
                            p{
                                font-size: 4vw;
                                font-family: "FZLT-blackLittle";
                                color: #333333;
                                text-align: center;
                                line-height: 4.6vw;
                                text-shadow: 0 0.3vw 0.7vw rgba(234, 234, 234, 0.5);
                            }
                            span{
                                display: none;
                                position: absolute;
                                bottom:-0.2vw;
                                left: 50%;
                                width: 4.5vw;
                                transform: translateX(-50%);
                                height: 0.7vw;
                                background: #C50819;
                                border-radius: 0.5vw;
                            }
                        }
                        .three-active{
                            p{
                                color: #C50819;
                            }
                            span{
                                display: block;
                            }
                        }
                    }
                }
                .main{
                    width: 100%;
                    padding: 3.3vw 0 0;
                    // padding-right: pxToVw(20);
                    .main-list{
                        width: 100%;
                        height: 100%;
                        position: relative;
                        display: flex;
                        flex-wrap: wrap;
                        // background: rgba(255, 255, 255, 0.9);
                        // padding: pxToVw(20) 0;
                        // box-shadow: 0px 0px pxToVw(27) 0px rgba(231,231,231,0.5);
                        // border-radius: pxToVw(3);
                        // .main-list-one{
                        //     position: relative;
                        //     width: pxToVw(1540);
                        //     height: 100%;
                        //     padding: pxToVw(65) 0 0 pxToVw(30);
                        //     overflow-y: scroll;
                        //     scrollbar-width: none;
                        //     -ms-overflow-style: none;
                        //     &::-webkit-scrollbar{
                        //         width: 3px;
                        //         height: 100%;
                        //         background: none;
                        //     }
                        //     &::-webkit-scrollbar-track{
                        //         background: none;
                        //     }
                        //     &::-webkit-scrollbar-thumb{
                        //         background: rgba(221, 221, 221, 0.6);
                        //     }
                            .one-list{
                                width: 43.7vw;
                                height: 46.9vw;
                                margin: 0 3.5vw 2.8vw 0 ;
                                box-shadow: 0px 0px 1.6vw 0px rgba(235,235,235,0.5);
                                border-radius: 0px 0px 0.3vw 0.3vw;
                                background: #FFFFFF;
                                &:nth-child(2n){
                                    margin: 0 0 2.8vw 0 ;
                                }
                                .img{
                                    width: 43.7vw;
                                    height: 24.5vw;
                                    background: #E6E6E6;
                                    border-radius: 0.3vw;
                                    display: flex;
                                    align-items: center;
                                    img{
                                        vertical-align: top;
                                        // width: 43.7vw;
                                        width: 100%;
                                        height: 100%;
                                    }
                                }
                                .text{
                                    width: 100%;
                                    padding:0 2.7vw;
                                    .p{
                                        height: 10.1vw;
                                        overflow: hidden;
                                        font-size: 3.2vw;
                                        color: #AAAAAA;
                                        line-height: 4.9vw;
                                        display: -webkit-box;
                                        -webkit-line-clamp: 2;
                                        -webkit-box-orient: vertical;
                                        text-overflow :ellipsis; 
                                        overflow: hidden;
                                    }
                                    .title{
                                        margin: 3.2vw 0 1.2vw;
                                        font-size: 3.5vw;
                                        color: #333333;
                                        line-height: 4vw;
                                        overflow: hidden;
                                        text-overflow :ellipsis; 
                                        white-space: nowrap; 
                                    }
                                }
                            }
                        // }
                    }
                }
            }
        }
    }
}
</style>
 